var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBookmark = function SvgIconBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#092B49",
    d: "M18 3v17.063l-5.325-2.693-.675-.338-.675.338L6 20.062V3zm0-1.5H6A1.5 1.5 0 0 0 4.5 3v19.5l7.5-3.75 7.5 3.75V3A1.5 1.5 0 0 0 18 1.5"
  })));
};
export default SvgIconBookmark;